export const redirects = [
    {
        name: 'Info Peliculas',
        nameUrl: 'infopeliculas',
        url: 'https://play.google.com/store/apps/details?id=com.eduweidenbacher.infopeliculas'
    },
    {
        name: 'Dolarama',
        nameUrl: 'dolarama',
        url: 'https://play.google.com/store/apps/details?id=com.eduweidenbacher.dolarama_arg'
    },

    {
        name: 'Old Portfolio',
        nameUrl: 'oldportfolio',
        url: 'https://old.edu-dev.ar'
    },
]